import type { EditOrderFormInputs } from '@src/orders/schemas/EditOrderFormInputs';

export const OrderEntriesComparator = {
  hasChanged: ({
    previousValues,
    values,
  }: {
    previousValues: EditOrderFormInputs;
    values: EditOrderFormInputs;
  }) => {
    const entries = Object.entries(values);

    for (const [key, value] of entries) {
      const previousValue = previousValues[key];
      const valueIsEmpty =
        !value || (Array.isArray(value) && value.length === 0);
      const defaultValueIsEmpty =
        !previousValue ||
        (Array.isArray(previousValue) && previousValue.length === 0);

      const canNotCompare = valueIsEmpty && defaultValueIsEmpty;
      const canCompare = !canNotCompare;

      if (
        canCompare &&
        JSON.stringify(previousValue) !== JSON.stringify(value)
      ) {
        return true;
      }
    }
    return false;
  },
};
